/**
 * Service for laboratory charts.
 */
const ChartService = () => {
    return {
        /**
         * The color palette for the charts.
         */
        colorPalette() {
            return [
                "#3513E2",
                "#718AFF",
                "#034e2e",
                "#2a6179",
                "#27a58c",
                "#6F08AF",
                "#DB9200",
                "#F06453",
                "#CC3363",
                "#89023E",
                "#FFD700",
                "#c9bf73"
            ];
        }

        /**
         * Get the color for a specific index in the color palette.
         *
         * @param index The index of the color.
         * @returns The color at the specified index.
         */
        , getColor(index: number): string {
            const palette = this.colorPalette();
            return palette[index % palette.length];
        }
    };
};

export default ChartService();
